import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-[#020617] text-white">
      {/* Header */}
      <nav className="bg-[#0f172a] border-b border-slate-800 px-4 md:px-8 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-amber-500 rounded-lg flex items-center justify-center">
              <Home className="w-4 h-4 text-white" />
            </div>
            <span className="font-bold">Thames Mortgage & Protection</span>
          </Link>
          <Link to="/" className="flex items-center gap-2 text-slate-400 hover:text-white text-sm">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-12">
        <h1 className="text-3xl font-bold mb-8">Cookie Policy</h1>
        
        <div className="prose prose-invert prose-slate max-w-none space-y-6 text-slate-300">
          <h2 className="text-xl font-semibold text-white">What Are Cookies?</h2>
          <p>
            A cookie is a small text file which your browser stores on your device. Cookies are transferred to 
            your device's permanent storage when you visit our website to allow the site to recognise you when 
            you visit our website again and to enable us to improve your use of the site.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8">Types of Cookies</h2>
          <p>Cookies may be:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Temporary (or "session") cookies:</strong> These are only in use while you visit our website 
              and are deleted when you close your browser.
            </li>
            <li>
              <strong>Permanent cookies:</strong> These stay on your device's permanent storage after you leave 
              our website until you delete them manually or your browser deletes them after a period of time.
            </li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8">How We Use Cookies</h2>
          <p>
            We may use temporary cookies in order to remember you as you use our website, but we also allow 
            third parties (particularly Google) to use analytical cookies (both temporary and permanent) on 
            our website to compile aggregate information about the areas of our website that are visited most frequently.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8">Your Cookie Choices</h2>
          <p>
            Most web browser settings are set for you to accept both our own cookies and third party cookies. 
            However, you are able to adjust those settings (in relation to both our own cookies and those of 
            third parties) to:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Accept the cookies</li>
            <li>Prompt you to accept or refuse a cookie each time one is sent</li>
            <li>Reject all cookies outright</li>
          </ul>

          <h2 className="text-xl font-semibold text-white mt-8">Our Recommendation</h2>
          <p>
            We recommend that, for the highest functionality of the website, you accept both our own cookies 
            and third party cookies. Browser settings can be changed in your tool bar.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8">Third Party Cookies</h2>
          <p>
            We use Google Analytics to help us understand how visitors use our website. Google Analytics uses 
            cookies to collect information about your visit. This information is used to compile reports and 
            help us improve our website. The cookies collect information in an anonymous form, including the 
            number of visitors to the website, where visitors have come to the website from, and the pages they visited.
          </p>
          <p className="mt-4">
            For more information on Google Analytics cookies, please see Google's privacy policy at{" "}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">
              policies.google.com/privacy
            </a>.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8">Contact Us</h2>
          <p>
            If you have any questions about our use of cookies, please contact us at{" "}
            <strong>admin@thamesresi.com</strong> or write to us at Millharbour Court, 6 Watergate Walk, 
            London, E14 9XH.
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-slate-800 py-8 px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center text-slate-500 text-sm">
          <p>© 2026 Thames Mortgage & Protection Ltd. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
